import React from 'react';

function Temp() {
    return (
        <div>ha ha ha</div>
    );
}

export default Temp;